// extracted by mini-css-extract-plugin
export default {"title-caption":"top-up-modal_title-caption__sQl30","modal-field-wrap":"top-up-modal_modal-field-wrap__vjk3t","input":"top-up-modal_input__WhplF"};